export const FS_LABEL = { da_incassare: "Da incassare", incassato: "Incassato", da_pagare: "Da pagare", pagato: "Pagato" };
export const FS_CLASS = {
  da_incassare: "border-amber-300 bg-amber-50 text-amber-800",
  incassato: "border-emerald-300 bg-emerald-50 text-emerald-800",
  da_pagare: "border-amber-300 bg-amber-50 text-amber-800",
  pagato: "border-emerald-300 bg-emerald-50 text-emerald-800",
};
export const INV_LABEL = { na: "—", da_fatturare: "Da fatturare", fatturato: "Fatturato" };
export const isClosed = (fs) => fs === "incassato" || fs === "pagato";
export const toggleStatus = (m) => {
  if (m.type === "income") return m.financial_status === "incassato" ? "da_incassare" : "incassato";
  return m.financial_status === "pagato" ? "da_pagare" : "pagato";
};
export const SOURCE_LABEL = { manuale: "Manuale", rendiconto: "Rendiconto", pulizie: "Registro pulizie", consumabile: "Consumabile", manutenzione: "Manutenzione" };

export const TREATMENTS = {
  consumabile: [
    { v: "puravida", l: "A carico PuraVida (uscita PuraVida)" },
    { v: "anticipato_riaddebito", l: "Anticipato PuraVida + riaddebito proprietario" },
    { v: "proprietario", l: "A carico proprietario / pagamento diretto" },
    { v: "nessuno", l: "Nessun movimento finanziario" },
  ],
  manutenzione: [
    { v: "proprietario", l: "A carico proprietario" },
    { v: "anticipato_riaddebito", l: "Anticipata PuraVida + riaddebito" },
    { v: "puravida", l: "A carico PuraVida" },
    { v: "fornitore_diretto", l: "Fornitore fattura direttamente al proprietario" },
  ],
};
export const treatmentLabel = (kind, v) => TREATMENTS[kind].find((t) => t.v === v)?.l || "Non specificato";
export const today = () => new Date().toISOString().slice(0, 10);
